import { render, staticRenderFns } from "./MissionMenu.vue?vue&type=template&id=2e876210"
import script from "./MissionMenu.vue?vue&type=script&lang=js"
export * from "./MissionMenu.vue?vue&type=script&lang=js"
import style0 from "./MissionMenu.vue?vue&type=style&index=0&id=2e876210&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports